import React, { Component } from 'react';
import { HeaderSub } from '../../Common/HeaderSub'
import { ProcessMgrList } from './ProcessMgrList';
import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당: 이재호
 * 화면기능: 처리내역 Index
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.ProcessMgrList,  //기본 컴포넌트 할당
            ContentState: null
        };
        this.CsName = Big3Common.ContentState;
    }
    //호출할 컴포넌트 이름
    CompName = {
        "ProcessMgrList": "ProcessMgrList",
    }
    //초기화
    componentDidMount() {  
        const Param_Uid = Big3Common.Util.GetParams("uid");
        //처리내역
        const ContentState = {
            [this.CsName.Uid]: Param_Uid
        }
        this.setState({
            ContentState: ContentState
        });
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.ProcessMgrList) {
            //처리내역
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="처리내역"
                        LinkUrl={"/MyPage/MyInfoMgr/Index"}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <ProcessMgrList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else {
            return (
                <div>
                    페이지가 없습니다
                </div>
            )
        }
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
